import { updateFavoriteItem } from "@shared/actions/games";
import { Button } from "@shared/components";
import { FavoriteButton } from "@shared/components/Common/FavoriteButton";
import { useIsAuth } from "@shared/hooks/user";
import { emitter } from "@shared/modules/core";
import { gamesService } from "@shared/services/GamesService/GamesService";
import React, { memo } from "react";
import { FormattedMessage } from "react-intl";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

const Card = ({
  name,
  description,
  pic,
  string_id,
  is_hidden,
  is_jackpot = false,
  is_new = false,
  is_favorite = false,
  id,
  wallet_integration,
}) => {
  const isAuth = useIsAuth();
  const [isFavorite, setFavorite] = React.useState(is_favorite);
  const dispatch = useDispatch();
  const histroy = useHistory();

  const handleWarningModalOpen = () => {
    emitter.emit("OPEN_WARNING_MODAL", {
      handleSessionStart: () => histroy.push(`/games/${string_id}`),
    });
  };

  const authButtonAction = () => {
    if (!isAuth) {
      histroy.replace("/", {
        showAuthModal: true,
      });
    } else if (wallet_integration) {
      handleWarningModalOpen();
    } else {
      histroy.push(`/games/${string_id}`);
    }
  };

  const setGameFavorite = async () => {
    setFavorite((prev) => !prev);
    const gameId = await gamesService.updateGameFavoriteStatus(id, !isFavorite);
    if (gameId) {
      dispatch(updateFavoriteItem(id, !isFavorite));
    } else {
      dispatch(updateFavoriteItem(id, isFavorite));
    }
  };

  const starButtonStatic = () => {
    if (isAuth && isFavorite) {
      return (
        <FavoriteButton
          onClick={setGameFavorite}
          isActive={isFavorite}
          variant={"star"}
        />
      );
    }
  };

  return (
    <div
      className="object catalog__item"
      style={{ display: is_hidden ? "none" : "" }}
      role="listitem"
    >
      <div className="object__inner">
        {is_jackpot && (
          <span className="object__tooltip object__tooltip--jp">Jackpot</span>
        )}
        {is_new && (
          <span className="object__tooltip object__tooltip--new">New</span>
        )}
        <LazyLoadImage src={pic} alt={name} className="object__img" />
        <div className="button-star-wrapper">{starButtonStatic()}</div>

        <div className="object__content">
          {description}
          {isAuth && (
            <div className="button-star-wrapper">
              <FavoriteButton
                onClick={setGameFavorite}
                isActive={isFavorite}
                variant={"star"}
              />
            </div>
          )}
          <Button
            tagName="button"
            className="btn btn--secondary btn--lg object__btn"
            onClick={authButtonAction}
          >
            <FormattedMessage id="boilerplate.components.Game.Card.Play" />
          </Button>
        </div>
      </div>

      <div className="object__title">{name}</div>
    </div>
  );
};

export default memo(Card);
